// utils/auth.js
import {useStorage} from '@vueuse/core'

const TokenKey = import.meta.env.VITE_APP_AUTH_TOKEN_KEY

// 使用 useStorage 管理 token（默认存 localStorage，关浏览器不丢失）
export const tokenRef = useStorage(TokenKey, '')

export function getToken() {
    return tokenRef.value
}

export function setToken(token) {
    tokenRef.value = token
}

export function removeToken() {
    tokenRef.value = null
}